export const validSocials = ['facebook', 'instagram', 'pinterest', 'twitter', 'tiktok'];
